import Icon from '../components/Icon.vue'

Icon.register({
  'angle-right': {
    width: 256,
    height: 512,
    paths: [
      {
        d: 'M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9l22.5-22.8c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6 0.1 34z'
      }
    ]
  }
})
